import { doc, getDoc, DocumentData } from 'firebase/firestore';
import { dataBase } from './firebaseConfig';
import { COLLECTIONS } from '../constants';

export const getFirestoreItem = async <T = DocumentData>(
  id: string,
  collectionName: string = COLLECTIONS.listings,
): Promise<T | null> => {
  try {
    const docRef = doc(dataBase, collectionName, id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return { ...docSnap.data(), id } as T;
    } else {
      console.log('Item does not exist');
      return null;
    }
  } catch (error) {
    console.error('Error while getting item', error);
    return null;
  }
};
